import {useCallback, useState} from "react";
import useProgressiveInput from "../../../../../../hooks/useProgressiveInput";
import ServiceRequestsService from "../../../../../../api/serviceRequestsService";

export const useFaqDialog = () => {
    const [searchText, setSearchText] = useState("");
    const [setTimeoutFaq, clearTimeoutFaq] = useProgressiveInput(
        (searchBy) => fetchFaqs(searchBy),
        1500
    );
    const [accordionData, setAccordionData] = useState([]);
    const [loadingAccordionData, setLoadingAccordionData] = useState(true);

    const fetchFaqs = useCallback((searchBy) => {
        setLoadingAccordionData(true);
        ServiceRequestsService.fetchFaqs(searchBy)
            .then(res => {
                setAccordionData(res.data);
            })
            .catch(e => {
                setAccordionData([]);
                console.error(e);
            })
            .finally(() => {
                setLoadingAccordionData(false);
            })
    }, []);

    const handleSearchChange = (e) => {
        setSearchText(e.target.value)
        setTimeoutFaq(e.target.value);
    }

    const handleSearchKeyPress = (e) => {
        if (e.which !== 13)
            return;

        clearTimeoutFaq();
        fetchFaqs(searchText);
    }

    return [accordionData, loadingAccordionData, searchText, handleSearchChange, handleSearchKeyPress, fetchFaqs];
}